import React from 'react';
import { Url } from '@wix/da-url';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import ContentByUser from '../../../_partials/ContentByUser';
import { ResourceType } from '../../../../types/resource';
import s from './CollectionBlock.scss';
const CollectionBlock = ({ collection, deviations, parentDeviation })=>{
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionid: collection.folderId
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['collection-header']
    }, /*#__PURE__*/ React.createElement(ContentByUser, {
        contentUrl: Url.userGalleryLink({
            username: collection.owner.username,
            gallectionType: 'collection',
            folderId: collection.folderId,
            folderName: collection.name
        }),
        contentTitle: collection.name,
        biData: BiData({
            evid: 100,
            sectionname: 'collections',
            typeid: ResourceType.COLLECTION,
            itemid: collection.folderId,
            page_typeid: BiContextProvidedValue,
            page_itemid: BiContextProvidedValue
        })
    })), /*#__PURE__*/ React.createElement(DeviationSidebarGrid, {
        streamId: `devpage-sidebar-collections-${parentDeviation.deviationId}-${collection.folderId}`,
        parentDeviation: parentDeviation,
        deviations: deviations,
        maxRows: 1
    }));
};
CollectionBlock.displayName = 'CollectionBlock';
export default CollectionBlock;
